import { Column } from '@atom-web/micros'
import { Text } from '@pyt/micros'
import Image from 'next/image'
import styled from 'styled-components'

import SocialMediaRatings from '../micros/SocialMediaRatings'

const LeftSidePanel = styled.div`
	width: 40%;
	padding: 48px 36px 40px;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: 50%;
	color: #fff;
	position: relative;
	display: flex;
	border-radius: 8px 0 0 8px;

	background-image: url('https://pyt-images.imgix.net/images/web_app/gcm/gcm-left-pane.png');

	:before {
		content: '';
		background: linear-gradient(0deg, rgba(0, 0, 0, 0.21), rgba(0, 0, 0, 0.21));
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		position: absolute;
		border-radius: 8px 0 0 8px;
	}
`

const LeftSideBanner = () => {
	return (
		<LeftSidePanel>
			<Column
				justify={'between'}
				css={{
					width: '100%',
				}}
			>
				<Image
					src="images/web_app/logo/pickyourtrail-logo-white.svg"
					alt="pyt-logo"
					width={140}
					height={24}
					layout="fixed"
				/>
				<Column css={{ gap: '12px' }}>
					<SocialMediaRatings />
					<Column css={{ gap: '8px' }}>
						<Text color="#fff">
							“PYT is the new-age travel company that is making waves with their
							excellent customer service”
						</Text>
						<Text color="#fff" fontWeight={600}>
							Raghuram
						</Text>
					</Column>
				</Column>
			</Column>
		</LeftSidePanel>
	)
}

export default LeftSideBanner
